import { CANCELLED } from "dns";

export enum SaveStatus {
  SAVED = 'SAVED',
  INPROGRESS = 'INPROGRESS',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  OUTDATED = 'OUTDATED',
  NOTSTARTED = 'NOTSTARTED'
}